import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../constant.js";
import Modal from "react-modal";
Modal.setAppElement("#root");

const Cancleorder = ({ orderid, Tradestarus }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [err, setError] = useState("");
  const [status, setStatus] = useState("");
  const [confurm, setconfurm] = useState("");
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    Tradestarus(2, 2);
  };
  const closeModal2 = () => {
    setIsOpen(false);
  };
  const customStyles = {
    content: {
      width: "200px",
      height: "10px",
      margin: "auto",
      border: "1px solid #ccc",
    },
  };
  const confarmation = (con) => {
    setStatus("");
    setconfurm(con);
    openModal();
  };
  const ordertype = async (type) => {
    // console.log('Type : '+type)
    closeModal();
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", token);
    formdata.append("orderID", type);
    formdata.append("type", 4);
    const result = await axios.post(
      baseUrl + `authController/closeCancelTrade`,
      formdata,
    );
    setResponse(result.data.message);
    setStatus(result.data.status);
    openModal();
    setconfurm("");
  };
  return (
    <>
      <div className="close_section" style={{ margin: "7px" }}>
        <button
          type="button"
          onClick={() => confarmation(3)}
          style={{
            border: "1px solid #ed0017",
            marginRight: "10px",
            padding: "2px 10px",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "10px",
            background: "#ed0017",
          }}
        >
          Close All MCX Orders
        </button>
        <button
          type="button"
          onClick={() => confarmation(4)}
          style={{
            border: "1px solid #ed0017",
            padding: "2px 10px",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "10px",
            background: "#ed0017",
          }}
        >
          Close All NSE Orders
        </button>
      </div>

      {confurm == 3 && (
        <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
          <div className="module-content">
            <h6>
              Are you sure you wnt to
              <br />
              close all MCX orders?
            </h6>
            <div style={{ display: "flex" }}>
              <button onClick={closeModal}>DECILNE</button>
              <button onClick={() => ordertype(1)}>CONFIRM</button>
            </div>
          </div>
        </Modal>
      )}
      {confurm == 4 && (
        <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
          <div className="module-content">
            <h6>
              Are you sure you wnt to
              <br />
              close all NSE orders?
            </h6>
            <div style={{ display: "flex" }}>
              <button onClick={closeModal}>DECILNE</button>
              <button onClick={() => ordertype(2)}>CONFIRM</button>
            </div>
          </div>
        </Modal>
      )}
      {status === 1 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            src="assets/img/icons/checked.png"
            className="img-fluid color_icons"
          />
          <h2>Order Detail</h2>
          <p>{response}</p>
          <button onClick={closeModal}>Ok</button>
        </Modal>
      )}
      {status === 0 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            src="assets/img/icons/failed.png"
            className="img-fluid color_icons"
          />
          <h2>Order Detail</h2>
          <p>{response}</p>
          <button onClick={closeModal}>Ok</button>
        </Modal>
      )}
    </>
  );
};

export default Cancleorder;
